import { NavIntegrationItems } from '@/types';
import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react';

export const INTEGRATION_STATUS = {
    CANCELLED: 0,
    ACTIVE: 1,
    ERRORED: 2,
};

export const GENERIC_STATUS = {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    DELETED: 'deleted',
};

export const DATE_FORMAT = {
    ISO_8601_DATE: 'yyyy-MM-dd',
    USER_DATE: 'MMM d, yyyy',
    DATE_TIME_FORMAT_AM_PM: 'yyyy-MM-dd hh:mm aa',
};

export const THEME_DEFAULTS = {
    DEFAULT_BG: '#f3f6fd',
    DEFAULT_HIGHLIGHT_COLOR: '#5383ff',
    DEFAULT_FONT: 'Grobek',
    DEFAULT_TEXT_COLOR: '#131f60',
};

export const MFA = {
    DEFAULT_TTL_DAYS: 7,
    FLOW_STAGES: {
        METHOD_CHOICE: 1,
        AUTHENTICATOR_APP: 2,
        OTP_NOTIFICATION: 3,
        VERIFY_CODE: 4,
        SAVE_RECOVERY_CODES: 5,
        COMPLETE_CONFIUGRATION: 6,
    },
};

export const QUERY_KEYS = {
    USER: 'user',
    CONVERSATIONS: 'conversations',
};

export const INTEGRATION_TYPES = {
    NOTION: 'notion',
    SLACK: 'slack',
};

export const SIDEBAR_DATA: {
    user: { name: string; email: string; avatar: string };
} = {
    user: {
        name: 'shadcn',
        email: 'm@example.com',
        avatar: '/avatars/shadcn.jpg',
    },
};

// TODO: delete this
export const TEAMS = [
    {
        name: 'Acme Inc',
        logo: GalleryVerticalEnd,
        plan: 'Enterprise',
    },
    {
        name: 'Acme Corp.',
        logo: AudioWaveform,
        plan: 'Startup',
    },
    {
        name: 'Evil Corp.',
        logo: Command,
        plan: 'Free',
    },
];
export const INTEGRATIONS: NavIntegrationItems = [
    {
        name: 'Notion',
        logoSrc: '/images/notion-logo.png',
        url: '/integrations/notion',
        type: INTEGRATION_TYPES.NOTION,
    },
    {
        name: 'Slack',
        logoSrc: '/images/slack-logo.png',
        url: '/integrations/slack',
        type: INTEGRATION_TYPES.SLACK,
    },
];
